import React from 'react';
import { motion } from 'framer-motion';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { ArrowRight } from 'lucide-react';
const news = [{
  image: 'https://cdn.magicpatterns.com/uploads/aTcv34Z4qXvX63GvUpWSNS/achivement.jpg',
  category: 'Achievement',
  date: 'March 12, 2026',
  title: 'MDIC Students Win National Science Olympiad',
  summary: 'Our talented students secured first place in the National Science Olympiad, showcasing exceptional knowledge and problem-solving skills.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/81cSdTvFwMGiiw2bpa2uL4/culture.jpg',
  category: 'Event',
  date: 'March 8, 2026',
  title: 'Annual Cultural Program Celebrates Diversity',
  summary: 'The school hosted a vibrant cultural program featuring performances from students representing various cultural traditions.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/5RACoB7cu7hUiPbNHCLfyW/science_fair.jpg',
  category: 'Academic',
  date: 'March 5, 2026',
  title: 'Science Fair Showcases Student Innovation',
  summary: 'Students presented groundbreaking science projects at the annual Science Fair, demonstrating creativity and scientific inquiry across multiple disciplines.'
}];
export function RecentNews() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="py-20 bg-light-gray" data-id="element-257">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-258">
        <div className="text-center mb-16" data-id="element-259">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-text-dark mb-4" data-id="element-260">
            Recent News
          </h2>
          <div className="h-1 w-24 bg-gold mx-auto mb-4" data-id="element-261"></div>
          <p className="text-lg text-text-muted max-w-2xl mx-auto" data-id="element-262">
            Stay informed about the latest happenings at MDIC
          </p>
        </div>

        <div ref={ref} className="grid md:grid-cols-3 gap-8" data-id="element-263">
          {news.map((item, index) => <motion.article key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isVisible ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-white rounded-lg shadow-md hover:shadow-xl transition-all overflow-hidden group" data-id="element-264">
              <div className="relative overflow-hidden h-48" data-id="element-265">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-266" />
                <div className="absolute top-4 left-4" data-id="element-267">
                  <span className="bg-primary text-white px-3 py-1 rounded-full text-xs font-semibold" data-id="element-268">
                    {item.category}
                  </span>
                </div>
              </div>
              <div className="p-6" data-id="element-269">
                <div className="text-sm text-text-muted mb-2" data-id="element-270">{item.date}</div>
                <h3 className="text-xl font-heading font-semibold text-text-dark mb-3 line-clamp-2" data-id="element-271">
                  {item.title}
                </h3>
                <p className="text-text-muted mb-4 line-clamp-3" data-id="element-272">
                  {item.summary}
                </p>
                <a href="#" className="inline-flex items-center gap-2 text-primary hover:text-primary-dark font-semibold transition-colors group" data-id="element-273">
                  Read More
                  <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-274" />
                </a>
              </div>
            </motion.article>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center mt-12" data-id="element-275">
          <a href="#" className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white px-8 py-3 rounded-lg font-semibold transition-colors" data-id="element-276">
            All News
            <ArrowRight size={18} data-id="element-277" />
          </a>
        </motion.div>
      </div>
    </section>;
}